// components/AdminLayout.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import LogoutButton from './LogoutButton';
import {
    LayoutDashboard,
    Image,
    Package,
    Megaphone,
    Menu,
    X,
    Info,
    Quote
} from 'lucide-react';

const AdminLayout = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = React.useState(false);
    const location = useLocation();

    const menuItems = [
        {
            path: '/admin',
            name: 'Dashboard',
            icon: <LayoutDashboard size={20} />,
            description: 'Panel principal'
        },
        {
            path: '/admin/about',
            name: 'Gestor de Nosotros',
            icon: <Info size={20} />,
            description: 'Administra el contenido de la sección Nosotros'
        },
        {
            path: '/admin/ads',
            name: 'Gestor de Anuncios',
            icon: <Megaphone size={20} />,
            description: 'Administra los anuncios del carrusel'
        },
        {
            path: '/admin/products',
            name: 'Gestor de Productos',
            icon: <Package size={20} />,
            description: 'Administra los productos'
        },
        {
            path: '/admin/gallery',
            name: 'Gestor de Galería',
            icon: <Image size={20} />,
            description: 'Administra las imágenes de la galería'
        },
        {
            path: '/admin/quotes',
            name: 'Cotizaciones',
            icon: <Quote size={20} />,
            description: 'Ver imágenes de cotizaciones'
        }
    ];

    const currentPage = menuItems.find(item => item.path === location.pathname);

    return (
        <div className="min-h-screen bg-gray-900">
            {/* Mobile menu button */}
            <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-gray-800 rounded-lg text-white flex"
            >
                {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
            </button>

            {/* Sidebar */}
            <motion.div
                initial={{ x: -300 }}
                animate={{ x: sidebarOpen ? 0 : -300 }}
                className={`fixed top-0 left-0 h-full w-64 bg-gray-800 shadow-2xl z-40 lg:translate-x-0 transition-transform duration-300 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
                    }`}
            >
                <div className="p-6">
                    <h2 className="text-2xl font-bold gradient-text mb-8">
                        Admin Panel
                    </h2>

                    <nav className="space-y-2">
                        {menuItems.map((item) => (
                            <Link
                                key={item.path}
                                to={item.path}
                                onClick={() => setSidebarOpen(false)}
                                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${location.pathname === item.path
                                    ? 'bg-primary text-white'
                                    : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                                    }`}
                            >
                                {item.icon}
                                <span>{item.name}</span>
                            </Link>
                        ))}
                    </nav>

                    <div className="absolute bottom-6 left-6 right-6">
                        <LogoutButton className="w-full justify-center" />
                    </div>
                </div>
            </motion.div>

            {/* Overlay for mobile */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 bg-black/50 z-30 lg:hidden"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            {/* Main content */}
            <div className="min-h-screen bg-gray-900 text-white p-4 md:p-6 max-w-6xl mx-auto">
                {/* Header */}
                <header className="bg-gray-800 border-b border-gray-700 p-4 sticky top-0 z-20  rounded-lg">
                    <div className="flex items-center justify-between">
                        <div className="ml-12 lg:ml-0">
                            <h1 className="text-xl font-bold text-white">
                                {currentPage?.name || 'Panel de Administración'}
                            </h1>
                            <p className="text-sm text-gray-400">
                                {currentPage?.description}
                            </p>
                        </div>

                        {/* Desktop logout button */}
                        <div className="hidden lg:block">
                            <LogoutButton />
                        </div>
                    </div>
                </header>

                {/* Page content */}
                <main className="p-6">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;